<template>
  <div
    v-on:mousemove="handleResultsMouseMove"
    v-on:mouseup="handleResultsMouseUp"
    id="query-edit-div"
  >
    <main-header
      :hasUnsavedChangesAndNotLoading="hasUnsavedChangesAndNotLoading"
      :query="query"
      @handleToggleLhsToolbar="handleToggleLhsToolbar"
      @handleQueryNameClick="handleQueryNameClick"
      @handleShareClick="handleShareClick"
      @handleToggleRhsProfileMenu="handleToggleRhsProfileMenu"
    ></main-header>

    <main-menu
      :drawerOptions="drawerOptions"
      @handleShowUserSettings="handleShowUserSettings"
      @handleLogin="handleLogin"
      @handleLogout="handleLogout"
      @hideMenu="hideMenu"
    ></main-menu>

    <profile-menu
      :profileDrawerOptions="profileDrawerOptions"
      @hideProfileMenu="hideProfileMenu"
      @handleLogin="handleLogin"
      @handleLogout="handleLogout"
    ></profile-menu>

    <canvas-nav-bar
      :hasUnsavedChanges="!isLoading && hasUnsavedChanges"
      @handleSearchAIClick="handleSearchAIClick"
      @handleNewCanvasClick="handleNewCanvasClick"
      @handleUndoClick="handleUndoClick"
      @handleRedoClick="handleRedoClick"
      @handleSaveClick="handleSaveClick"
      @handleClearCanvas="startNewQuery"
      @listQueries="listQueries"
      @handleImportClick="handleImportClick"
      @handleImportFileClick="handleImportFileClick"
      @handleLayoutViewClick="handleViewClick"
      @handleViewClick="handleViewClick"
      @handleTreeViewClick="handleTreeViewClick"
    ></canvas-nav-bar>

    <!--  Temporary Visual Components  -->
    <snackbar></snackbar>

    <loading-spinner></loading-spinner>

    <div
      id="div-cover-behind-results-slider"
      v-if="this.$store.state.appState.showResultsSection && this.lhsDragging"
    ></div>

    <results-section
      :lhsDragging.sync="lhsDragging"
      :targetEngine="targetEngine"
      @reloadResults="reloadResults"
      @newTabResults="newTabResults"
      @handleTargetEngineClick="handleTargetEngineClick"
      @toggleResults="toggleResults"
      @handleCopyClick="handleCopyClick"
      @launchGeneratorQuery=launchGeneratorQuery($event)
      @handleSearchAIClick="handleSearchAIClick"
    >
    </results-section>
<!--    <v-slide-x-reverse-transition hide-on-leave="true">-->
<!--      <div-->
<!--        id="div-results"-->
<!--        v-show="showingResults"-->
<!--        v-bind:style="{ width: divResultsWidth + 'px' }"-->
<!--      >-->

<!--        <div-->
<!--          v-on:mousedown.stop.prevent="handleResultsMouseDown"-->
<!--          id="div-results-lhs"-->
<!--        >-->
<!--          <v-icon id="div-results-lhs-drag-icon">more_vert</v-icon>-->
<!--        </div>-->
<!--  @todo - Code Below - old tab in results pane (deprecated but: 'Messages', 'Query'(stats section) 'Generator' not yet moved to new design)  -->
<!--        <v-toolbar class="tdsToolbar" id="div-results-toolbar" flat height="15px">-->
<!--          <v-tabs-->
<!--            id="div-results-tabs"-->
<!--            slot="extension"-->
<!--            v-model="tabModel"-->
<!--          >-->
<!--            <v-tab :ripple=false href="#tab_results" class="pr-3">Results</v-tab>-->
<!--            <v-tab :ripple=false href="#tab_warnings" class="pr-3">-->
<!--              <v-badge right color="red" :value="messagesCount" class="tds-badge">-->
<!--                <span slot="badge">{{messagesCount}}</span>-->
<!--                <span>Messages</span>-->
<!--              </v-badge>-->
<!--            </v-tab>-->
<!--            <v-tab :ripple=false href="#tab_query">Query</v-tab>-->
<!--            <v-tab :ripple=false href="#tab_generator">Generator</v-tab>-->
<!--          </v-tabs>-->
<!--        </v-toolbar>-->
<!--    -->
<!--        <v-tabs-items v-model="tabModel">-->
<!--          <v-tab-item id="tab_results">-->
<!--            <v-card flat height="100%" id="div-results-iframe">-->
<!--              <iframe v-if="targetEngine.showIFrameResults" class="uxl-results-frame" :src='resultsUrl'></iframe>-->
<!--              <v-card-text v-else class="tds-no-iframe-results text-xs-center">-->
<!--                <div>{{targetEngine.name}} results are displayed in a separate tab</div>-->
<!--                <button-results-new-tab @open="newTabResults" :title="`Open ${targetEngine.name} results`"></button-results-new-tab>-->
<!--              </v-card-text>-->
<!--              <div id="div-results-rhs" v-show="lhsDragging"></div>-->
<!--            </v-card>-->
<!--          </v-tab-item>-->
<!--    @todo - Message tab -->
<!--          <v-tab-item id="tab_warnings">-->
<!--            <v-card flat>-->
<!--              <v-card-text v-if="queryMessages && queryMessages.length<=0" class="uxl-meta-warning">Any warnings or error messages returned will be displayed here</v-card-text>-->
<!--              <div class="pt-5 pl-4 pr-4" v-else>-->
<!--                <div v-for="(item, index) in queryMessages" :key="index">-->
<!--                  <div v-if="item && item.items" class="pb-2">-->
<!--                    <div>{{item.title}}</div>-->
<!--                    <div class="pl-4">-->
<!--                      <div v-for="(subItem, subIndex) in item.items" :key="subIndex">-->
<!--                        <span>{{subItem}}</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div v-html="item" v-else class="pb-2"></div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </v-card>-->
<!--          </v-tab-item>-->
<!--    -->
<!--          <v-tab-item id="tab_query" class="tds-scroll">-->
<!--            <v-card flat>-->
<!--              <v-card-title class="headline">Statistics</v-card-title>-->
<!--              <v-card-text class="pt-0">-->
<!--  @todo - stats section of Query tab not yet moved to new design  -->
<!--                <table class="tds-statistics">-->
<!--                  <tr>-->
<!--                    <td>{{queryStatistics.termsText}}</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td>{{queryStatistics.fieldTagsText}}</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td>{{queryStatistics.operatorsText}}</td>-->
<!--                  </tr>-->
<!--                </table>-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--    -->
<!--            <v-card flat>-->
<!--              <v-card-title class="headline">-->
<!--                URL-->
<!--                <v-tooltip top>-->
<!--                  <span slot="activator" @click="handleCopyClick(resultsUrl, 'URL')" class="button">-->
<!--                    <v-icon slot="activator" class="copy-icon">content_copy</v-icon>-->
<!--                  </span>-->
<!--                  <span>Copy URL</span>-->
<!--                </v-tooltip>-->
<!--              </v-card-title>-->
<!--              <v-card-text class="pt-0">-->
<!--                <a :href="resultsUrl" target="_blank" ref="url_link" id="results-url-link">{{resultsUrl}}</a>-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--            <v-card flat>-->
<!--              <v-card-title class="headline">-->
<!--                Query string (for {{targetEngine.name}})-->
<!--                <v-tooltip top>-->
<!--                  <span slot="activator" @click="handleCopyClick(booleanString, 'Query string')" class="button">-->
<!--                    <v-icon slot="activator" class="copy-icon">content_copy</v-icon>-->
<!--                  </span>-->
<!--                  <span>Copy Query String</span>-->
<!--                </v-tooltip>-->
<!--              </v-card-title>-->
<!--              <v-card-text class="pt-0">-->
<!--                <div>{{booleanString}}</div>-->
<!--                <div v-if="targetEngine.searchEngine && targetEngine.searchEngine.syntaxGuideUrl" class="mt-3">-->
<!--                  <a :href="targetEngine.searchEngine.syntaxGuideUrl" target="_blank">Syntax guide</a>-->
<!--                  <span> for {{targetEngine.name}}</span>-->
<!--                </div>-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--  @todo - polyglot Queries -> not yet designed in v2  -->
<!--            <v-card flat v-show="showPolyglotQueries">-->
<!--              <v-card-text class="pt-0">-->
<!--                <PolyglotQueries :query="polyglotString"></PolyglotQueries>-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-tab-item>-->
<!--          <v-tab-item id="tab_generator">-->
<!--            <GeneratorTab @passFinalQuery="launchGeneratorQuery($event)" @showResultsTab="tabModel = $event"></GeneratorTab>-->
<!--          </v-tab-item>-->
<!--        </v-tabs-items>-->
<!--      </div>-->
<!--    </v-slide-x-reverse-transition>-->

    <!--  MAIN MENU MODALS  -->
    <new-search-modal
      :queryString.sync="parseStringModalBooleanString"
      :queries="queries"
      :hasUnsavedChanges="hasUnsavedChangesAndNotLoading"
      @close="handleNewSearchModalClose"
      @openBlankCanvas="handleOpenBlankCanvas"
      @openGenerator="handleSearchAIClick"
      @openCanvas="handleOpenCanvasWithId"
      @handleOpenCuratedSearch="handleOpenCuratedSearch"
      @handleSearchStringInput="handleNewSearchModalSearchStringInput($event)"
      @handleImportFileClick="handleImportFileClick"
      @handleFileDrop="handleFileDrop"
    ></new-search-modal>

    <new-canvas-confirmation-modal
      @confirmed="handleNewConfirmedClick"
    ></new-canvas-confirmation-modal>

    <open-search-strategy-modal
      :queries="queries"
      :defaultSearchName="defaultEngine.name"
      @confirm="handleConfirmOpen"
      @deleteCompleted="handleDeleteCompleted"
    ></open-search-strategy-modal>

    <add-to-canvas-modal
      :queries="queries"
      :defaultSearchName="defaultEngine.name"
      @confirm="handleConfirmImport"
    >
    </add-to-canvas-modal>

    <div v-if="showSaveModal">
      <saveAs-modal
        v-model="newQueryName"
        :title="$t('modal.save.title')"
        :customShowDialog="showSaveAsModal"
        :newQueryName="newQueryName"
        :queries="queries"
        @confirmed="handleSaveConfirmation"
        @close="handleSaveClose"
      ></saveAs-modal>
    </div>

    <div v-if="showSaveAsModal">
      <saveAs-modal
        v-model="saveAsName"
        :title="$t('modal.saveAs.title')"
        :customShowDialog="showSaveAsModal"
        :saveAsName="saveAsName"
        :queries="queries"
        @confirmed="(fileName) => handleSaveAsConfirmation(fileName)"
        @close="handleSaveAsClose"
      ></saveAs-modal>
    </div>

    <div v-if="showEnterQueryStringModal">
      <enter-query-string
        :model="parseStringModalBooleanString"
        @confirmed="handleParseStringConfirmation($event)"
        @close="handleEnterQueryStringClose"
      ></enter-query-string>
    </div>

    <div v-if="showGenerateSearchReport">
      <GenerateSearchReportModal
        :author="getName()"
        :summary="this.query ? this.query.notes : ''"
        :databaseName="this.targetEngine ? this.targetEngine.name : ''"
        :engines="enabledEngines"
        :graphRef="this.$refs.graph"
        :showShareLink="typeof this.id !== 'undefined'"
        :shareUrl="shareUrl"
        @close="hideMenu"
        @confirmed="handleGenerateConfirmation"
      ></GenerateSearchReportModal>
    </div>

    <!--  File Upload component  -->
    <v-content>
      <drop @drop='handleFileDrop'>
        <Graph
          ref="graph"
          :queryJson="queryBody"
          :bus="bus"
          :isTester="getIsTester()"
          :snapToGrid="snapToGrid"
          :layoutInline="isLayoutInline"
        />
      </drop>
      <input
        id="fileUploadInputField"
        type="file"
        multiple
        :name="uploadFieldName"
        @change="handleFilesChange($event.target.name, $event.target.files)"
        accept=".tds">
      <FloatingControls
        id="floatingControls"
        @centreDiagram="handleMainCentreDiagram"
        @increaseSemanticLevel="mainIncreaseSemanticLevel"
        @decreaseSemanticLevel="mainDecreaseSemanticLevel"
      />
<!--      <Tour :bus="bus"></Tour>-->
    </v-content>

    <user-settings-modal
      @updated="handleUserSettingsUpdated"
      @failed="handleUserSettingsUpdateFailed"
    ></user-settings-modal>
    <!--  END of main menu modals  -->

    <!--  ON MAIN HEADER MENU MODALS  -->
    <!--  Properties : accessed by clicking Canvas Name in Main Header  -->
    <properties-modal
      :newQueryName="newQueryName"
      :query="query"
      :confirmEnabled="!(newQueryName === null || newQueryName === '')"
      :queries="queries"
      :enabledEngines="enabledEngines"
      :newQueryDefaultSearch.sync="newQueryDefaultSearch"
      :newQueryDefaultOperator.sync="newQueryDefaultOperator"
      :newQueryNotes.sync="newQueryNotes"
      @confirmed="handleQuerySettingsConfirmation"
    ></properties-modal>

    <!--  TreeView of canvas Modal  -->
    <v-dialog v-model="showTreeView" scrollable max-width="90vw" persistent>
      <tree-view-modal
        @close="handleTreeViewClose"
        :confirmButton="$t('buttons.close')"
      >
        <div slot="body">
          <TreeViewGraph
            :queryJson="treeViewJson"
            :bus="bus"
            @queryUpdated="handleTreeViewQueryUpdated"
          />
          <FloatingControls
            id="treeViewFloatingControls"
            @centreDiagram="handleTreeViewCentreDiagram"
            @increaseSemanticLevel="treeViewIncreaseSemanticLevel"
            @decreaseSemanticLevel="treeViewDecreaseSemanticLevel"
          />
        </div>
      </tree-view-modal>
    </v-dialog>

    <!--  Share Strategy Modal  -->
    <share-modal
      :shareUrl="shareUrl"
      @confirmed="handleShareConfirmation"
    >
    </share-modal>

    <!--  Name Strategy Before Sharing Modal  -->
    <div v-if="showShareSetNameModal">
      <saveAs-modal
        v-model="newQueryName"
        :title="$t('modal.saveBeforeShare.title')"
        :newQueryName="newQueryName"
        :queries="queries"
        @confirmed="handleShareSetNameConfirmation"
        @close="handleShareSetNameClose"
      ></saveAs-modal>
    </div>

    <!--  STANDALONE MODALS  -->
    <!--  Info Modal: Used for Confirm Email & Unable to Fetch Data -->
    <information-modal></information-modal>

    <!--  Login Modal  -->
    <div v-if="showConfirmLogin">
      <login-modal
        @confirmed="handleLogin"
        @close="showConfirmLogin=false"
      ></login-modal>
    </div>

    <!--  Suggested terms : accessed via context menu (right click) of term on canvas > Suggest terms   -->
    <generated-keywords-modal
      :customShowDialog="showingSuggestTerms"
      :seedTerm="suggestTerms.term"
      :suggestions="suggestTerms.suggestions"
      :termKey="suggestTerms.termKey"
      :groupKey="suggestTerms.groupKey"
      :searchEngine="targetEngine.searchEngine"
      @close="handleSuggestTermsClose"
      @confirmed="handleSuggestTermsConfirmed"
    ></generated-keywords-modal>

    <PostIt></PostIt>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import {Drop} from 'vue-drag-drop'
import Sugar from 'sugar'
import { mapActions } from 'vuex'

import Graph from './Graph'
import DrawerOption from './DrawerOption'
import ResultsSection from './parts/ResultsContainer/ResultsSection'
import TreeViewGraph from './TreeViewGraph'

import {
  BaseModal,
  ConfirmationModal,
  InformationModal,
  LoginModal,
  PropertiesModal,
  ShareModal,
  GeneratedKeywordsModal,
  TreeViewModal,
  UserSettingsModal
} from './modals'

import {
  AddToCanvasModal,
  EnterQueryString,
  GenerateSearchReportModal,
  MainMenu,
  NewCanvasConfirmationModal,
  NewSearchModal,
  OpenSearchStrategyModal,
  SaveAsModal
} from './mainMenu'

import {
  CanvasNavBar,
  MainHeader,
  ProfileMenu,
  FloatingControls,
  SearchAI,
  PolyglotQueries,
  PostIt,
  QueryNameInput
} from './parts'

import {
  LoadingSpinner,
  Snackbar
} from './parts/utils'

import {createQuery, getQueries, getQuery, getQueryPublic, simpleLog, updateQuery} from '@/utils/queries-api'
import {statusEnum} from '@/utils/api-common'
import {
  clearLocalData,
  getIsTester,
  getLocalData,
  getProfile,
  getUserId,
  initialiseProfile,
  isEmailVerified,
  isLoggedIn,
  login,
  logout,
  saveCurrentPage,
  saveLocalData,
  saveTargetPath
} from '@/utils/auth'
import {
  clearUserDetails,
  getAddQuotesAroundPhrases,
  getDefaultSearch,
  getSnapToGrid,
  hasSeenTour,
  setHasSeenTour
} from '@/utils/user-details'
import {
  availableLayouts,
  inlineLayoutName,
  nestedLayoutName,
  aboutUrl,
  baseQueryAttributes,
  defaultOperatorName,
  fileExtension,
  howToUseUrl,
  requestDemoUrl
} from '@/utils/constants'
import {DEFAULT_ENGINE, POSSIBLE_ENGINES} from '@/utils/search-engines'
import {textToClipboard} from '@/utils/clipboard'
import {orderByOrdering} from '@/utils/ordering'
import {defaultQueryForDisplay} from '@/graph_parts/default_queries'
import PolyglotEngine from '@/formulate_queries/PolyglotEngine'
import PubMedEngine from '@/formulate_queries/PubMedEngine'
import {parse} from '@/parsing/parsing'
import {getRelevantKeywords} from '../utils/nlp-api-v2'

const LOCAL_DATA_KEY = 'query'
const EXTERNAL_RESULTS_WINDOW_NAME = '2DSearchExternalResults'

const orNotReplaceRE = new RegExp(' OR -', 'g')

export default {
  name: 'query-edit',
  components: {
    MainHeader,
    Drop,
    Graph,
    CanvasNavBar,
    ResultsSection,
    TreeViewGraph,
    EnterQueryString,
    LoginModal,
    MainMenu,
    NewCanvasConfirmationModal,
    NewSearchModal,
    ProfileMenu,
    OpenSearchStrategyModal,
    ConfirmationModal,
    SaveAsModal,
    PropertiesModal,
    InformationModal,
    ShareModal,
    TreeViewModal,
    DrawerOption,
    QueryNameInput,
    AddToCanvasModal,
    BaseModal,
    GeneratedKeywordsModal,
    LoadingSpinner,
    Snackbar,
    UserSettingsModal,
    Sugar,
    PolyglotQueries,
    FloatingControls,
    GenerateSearchReportModal,
    PostIt,
    SearchAI
  },
  props: ['id', 'importId', 'showDefaultQuery'],
  data () {
    let drawerOptions = [
      {isDivider: true, title: this.$t('menu.main.generateSection.title')},
      {action: this.handleSearchAIClick, icon: 'rebase_edit', title: this.$t('misc.ai.title'), isHighlighted: null},
      {action: this.handleEnterQueryStringClick, icon: 'short_text', title: this.$t('menu.main.generateSection.queryString'), isHighlighted: null},
      {action: this.handleGenerateSearchReport, icon: 'description', title: this.$t('menu.main.generateSection.searchReport'), isHighlighted: null},
      {isDivider: true, title: this.$t('menu.main.canvasSection.title')},
      {action: this.handleNewCanvasClick, icon: 'library_add', title: this.$t('menu.main.canvasSection.new'), isHighlighted: null},
      {action: this.listQueries, icon: 'file_open', title: this.$t('menu.main.canvasSection.open'), isHighlighted: null},
      {action: this.handleImportClick, icon: 'addchart', title: this.$t('menu.main.canvasSection.add'), isHighlighted: null},
      {action: this.handleSaveClick, icon: 'save', title: this.$t('menu.main.canvasSection.save'), isHighlighted: () => { return !this.isLoading && this.hasUnsavedChanges }},
      {action: this.handleImportFileClick, icon: 'upload_file', title: this.$t('menu.main.canvasSection.upload'), isHighlighted: null},
      {action: this.handleDownloadClick, icon: 'download_for_offline', title: this.$t('menu.main.canvasSection.download'), isHighlighted: null},
      {action: this.handleShareClick, icon: 'share', title: this.$t('menu.main.canvasSection.share'), isHighlighted: null}
    ]
    let profileDrawerOptions = [
      {isDivider: true, title: this.$t('menu.profile.userSection.title')},
      {action: this.handleShowUserSettings, icon: 'settings', title: this.$t('menu.profile.userSection.preferences'), isHighlighted: null},
      // {action: this.handleTourClick, icon: 'import_contacts', title: this.$t('menu.profile.userSection. 'Tutorial', isHighlighted: null},
      {isDivider: true, title: this.$t('menu.profile.companySection.title')},
      {action: this.handleHowToUseClick, icon: 'help_outline', title: this.$t('menu.profile.companySection.helpPage'), isHighlighted: null},
      {action: this.handleRequestDemoClick, icon: 'people_outline', title: this.$t('menu.profile.companySection.demoRequest'), isHighlighted: null},
      {action: this.handleAboutClick, icon: 'info_outline', title: this.$t('menu.profile.companySection.about'), isHighlighted: null}
    ]
    return {
      query: null,
      bus: new Vue(),
      queries: [],
      newQueryName: '',
      newQueryDefaultOperator: '',
      newQueryNotes: '',
      newIsPublic: false,
      newQueryDefaultSearch: null,
      saveAsName: '',
      saveAsDefaultSearch: '',
      drawerOptions: drawerOptions,
      profileDrawerOptions: profileDrawerOptions,
      // resultsUrl: '',
      hasUnsavedChanges: false,
      isLoading: typeof this.id !== 'undefined',
      isConfirmationBusy: false,
      // uplodaFileName never populated in this file
      uploadFieldName: null,
      lastIdLoadFailed: null,
      lhsDragging: false,
      externalResultsWindow: null,
      showingSuggestTerms: false,
      suggestTerms: {
        term: '',
        suggestions: [],
        termKey: null,
        groupKey: null
      },
      subqueryGraphData: null,
      parseStringModalBooleanString: null,
      parseStringModalError: null,
      possibleEngines: POSSIBLE_ENGINES,
      defaultEngine: DEFAULT_ENGINE,
      engineName: DEFAULT_ENGINE.name,
      targetEngine: DEFAULT_ENGINE,
      polyglotEngine: new PolyglotEngine(),
      pubMedEngine: new PubMedEngine(),
      snapToGrid: null,
      addQuotesAroundPhrases: true,
      showConfirmLogin: false,
      showTreeView: false,
      treeViewJson: null,
      querySyntax: 'polyglot',
      queryStatistics: {
        termsText: null,
        fieldTagsText: null,
        operatorsText: null
      }
      // updateSourceDropdownValue: DEFAULT_ENGINE.name,
    }
  },
  methods: {
    ...mapActions([
      'setResultsUrl'
    ]),
    getQuery (cb) {
      this.isLoading = true
      getQuery(this.id).then(r => {
        if (r.status === statusEnum.unauthorised) {
          this.lastIdLoadFailed = null
          this.loginWithConfirmation()
        } else if (r.status === statusEnum.error || r.status === statusEnum.notFound) {
          this.lastIdLoadFailed = this.id
          this.showCannotFetchDataInformation()
        } else if (r.status === statusEnum.ok) {
          this.lastIdLoadFailed = null
          this.query = r.response.query
          this.query.body = this._tidyUpQueryData(r.response.query.body)
          this.setTargetEngineFromName(r.response.query.defaultSearchName)
          this.$nextTick(() => {
            if (this.layout !== undefined) {
              this.bus.$emit('setOverallLayout', this.layout.toLowerCase())
            }
          })
          this.hasUnsavedChanges = false
          if (cb) {
            cb()
          }
        }
      })
    },
    _tidyUpQueryData (queryBodyString) {
      const r = JSON.parse(queryBodyString)
      if (r.nodeDataArray) {
        const groups = []
        r.nodeDataArray.forEach(node => {
          if (node.isGroup) {
            if (!groups.includes(node.key)) {
              groups[node.key] = []
            }
          }
        })
        r.nodeDataArray.forEach(node => {
          if (node.group) {
            groups[node.group].push(node)
          }
        })
        let hasDuplicateOrdering = false
        // Make sure ordering of items in each group is distinct
        for (let key in groups) {
          const group = groups[key]
          const orderings = []
          let hasNullOrdering = false
          group.forEach(node => {
            if (node.ordering !== null) {
              if (orderings.includes(node.ordering)) {
                hasDuplicateOrdering = true
              } else {
                orderings.push(node.ordering)
              }
            } else {
              hasNullOrdering = true
            }
          })
          if (hasDuplicateOrdering || hasNullOrdering) {
            group.sort(orderByOrdering)
            let ordering = 10
            group.forEach(node => {
              node.ordering = ordering
              ordering += 10
            })
          }
        }
      }
      return JSON.stringify(r)
    },
    setTargetEngineFromName (name) {
      this.targetEngine = this.getDefaultSearchFromName(name)
    },
    getDefaultSearchFromName (name) {
      let r = null
      if (name) {
        const m = this.possibleEngines.find(e => {
          return e.name === name
        })
        if (typeof m !== 'undefined') {
          r = m
        }
      }
      if (r === null) {
        r = this.defaultEngine
      }
      return r
    },
    // @todo - Used in Header Component
    handleToggleLhsToolbar () {
      if (!this.$store.state.modalState.showMainMenu) {
        this.bus.$emit('stopTour')
      }
      this.$store.commit('toggleShowMainMenu')
    },
    handleToggleRhsProfileMenu () {
      if (!this.$store.state.modalState.showProfileMenu) {
        this.bus.$emit('stopTour')
      }
      this.$store.commit('toggleShowProfileMenu')
    },
    // @todo - To be removed
    handleResultsMouseDown () {
      this.lhsDragging = true
      // this.$store.commit('setResultsContainerResizeDragging', true)
      // console.log('resize started')
    },
    handleResultsMouseUp (e) {
      // if (this.lhsDragging) {
      if (this.lhsDragging) {
        e.stopPropagation()
        this.lhsDragging = false
        // this.$store.commit('setResultsContainerResizeDragging', false)
        // console.log('resize stopped')
      }
    },
    handleResultsMouseMove (e) {
      if (this.lhsDragging) {
      // if (this.$store.state.appState.resultsContainerResizeDragging) {
      //   console.log('window.innerWidth:', window.innerWidth - e.clientX)
        this.$store.commit('setResultsContainerWidth', window.innerWidth - e.clientX)
        // console.log('resultsWidth:', this.$store.state.appState.resultsContainerResizeDragging)
      }
    },
    handleTargetEngineClick (engineName) {
      if (typeof engineName === 'object') {
        engineName = engineName.name;
      }
      this.targetEngine = this.possibleEngines.filter(engine => engine.name === engineName)[0]
      if (!this.targetEngine.searchEngine.canGetCount()) {
        this.bus.$emit('clearCounts')
      }
      this.updateResults()
      this.refreshQueryMessages()
      this.$store.commit('setShowResultsSection', true)
      this.$store.commit('showResultsComponent')
    },
    refreshQueryMessages () {
      this.$store.commit('setQueryMessage', this.targetEngine.searchEngine.lintQuery(this.getQueryGraphData()))
    },
    getQueryGraphData () {
      let queryGraphData = null
      if (this.subqueryGraphData === null) {
        const s = this.$refs.graph.getTreeData(this.query
          ? this.query.defaultOperator
          : defaultOperatorName)
        queryGraphData = s
      } else {
        queryGraphData = this.subqueryGraphData
      }
      return queryGraphData
    },
    handleUndoClick () {
      this.bus.$emit('undo')
    },
    handleRedoClick () {
      this.bus.$emit('redo')
    },
    handleCopyClick (copyText, type) {
      if (typeof copyText === 'object') {
        type = copyText[1]
        copyText = copyText[0]
      }
      this.showSnackbar(type + this.$t('notification.snackbar.clipboardCopy'))
      navigator.clipboard.writeText(copyText)
    },
    handleMainCentreDiagram () {
      this.bus.$emit('centreDiagram')
    },
    mainIncreaseSemanticLevel () {
      this.bus.$emit('increaseSemanticLevel')
    },
    mainDecreaseSemanticLevel () {
      this.bus.$emit('decreaseSemanticLevel')
    },
    handleTreeViewCentreDiagram () {
      this.bus.$emit('treeViewCentreDiagram')
    },
    treeViewIncreaseSemanticLevel () {
      this.bus.$emit('treeViewIncreaseSemanticLevel')
    },
    treeViewDecreaseSemanticLevel () {
      this.bus.$emit('treeViewDecreaseSemanticLevel')
    },
    handleConfirmOpen (id) {
      this.$store.commit('setShowListQueriesModal', false)
      // Clear this so that results are reloaded and duplicates checked on newly loaded query
      // this.resultsUrl = null
      this.setResultsUrl(null)
      this.$router.push({ name: 'Query', params: { id: id } })
    },
    handleDeleteCompleted () {
      this.showSnackbar(this.$t('notification.snackbar.fileDeleted'))
      this.loadQueriesData()
    },
    handleConfirmImport (id) {
      if (this._saveLocalAndEnsureLoggedIn()) {
        this.$store.commit('setShowImportModal', false)
        getQuery(id).then(r => {
          if (r.status === statusEnum.error) {
            this.showSnackbar(this.$t('notification.snackbar.importFailed'))
          } else if (r.status === statusEnum.ok) {
            this.bus.$emit('addData', JSON.parse(r.response.query.body).nodeDataArray)
          }
        })
      }
    },
    handleSearchAIClick () {
      this.$store.dispatch('handleSearchAIClick')
    },
    _processParseInput () {
      return new Promise((resolve, reject) => {
        window.setTimeout(() => {
          const logMessage = {
            inputText: this.parseStringModalBooleanString,
            createdAt: new Date(),
            userId: getUserId(),
            userName: this.getName(),
            emailAddress: this.getEmailAddress(),
            isPolyglotParser: this.querySyntax === 'polyglot'
          }
          try {
            this.parseStringModalError = null
            const q = parse(this.parseStringModalBooleanString, this.querySyntax)
            if (q) {
              this.bus.$emit('addSimpleTree', q)
              this.updateResults()
            }
            this.showParseStringModal = false
            logMessage.parsedSuccessfully = true
            simpleLog(logMessage)
            this.$store.commit('setShowEnterQueryStringModal', false)
          } catch (e) {
            this.parseStringModalError = this.$t('notification.snackbar.queryStringFailed')
            this.showSnackbar(this.parseStringModalError)
            if (typeof e === 'object' && e.hasOwnProperty('location')) {
              const minCharsStart = 20
              const minCharsEnd = 10
              let start = e.location.start.offset > minCharsStart ? e.location.start.offset - minCharsStart : 0
              let end = e.location.end.offset < this.parseStringModalBooleanString.length - minCharsEnd
                ? e.location.end.offset + minCharsEnd : this.parseStringModalBooleanString.length
              this.parseStringModalError += this.$('notification.snackbar.problemAt') + '<span class="tds-highlight-error">' +
                this.parseStringModalBooleanString.substring(start,
                  e.location.start.offset) +
                '<span class="tds-highlight-error-characters">' +
                this.parseStringModalBooleanString.substring(e.location.start.offset,
                  e.location.end.offset) +
                '</span>' +
                this.parseStringModalBooleanString.substring(e.location.end.offset, end) + '</span>.'
            }
            logMessage.parsedSuccessfully = false
            simpleLog(logMessage)
          }
          resolve()
        }, 100)
      })
    },
    handleNewSearchModalSearchStringInput (input) {
      // @todo - potentially move this to the func below?
      this.$store.commit('setShowNewSearchModal', false)
      this.handleParseStringConfirmation(input)
    },
    handleParseStringConfirmation ([userInput, querySyntaxMethod]) {
      this.parseStringModalBooleanString = userInput
      this.querySyntax = querySyntaxMethod
      if (this.parseStringModalBooleanString) {
        this.isConfirmationBusy = true
        this._processParseInput().then(() => { // Use promise and setTimeout so that spinner shows before parsing finishes
          this.isConfirmationBusy = false
        })
      }
    },
    handleEnterQueryStringClose () {
      this.$store.commit('setShowEnterQueryStringModal', false)
      this.$store.commit('setShowMainMenu', false)
    },
    handleShareClick () {
      this.bus.$emit('stopTour')
      if (this._saveLocalAndEnsureLoggedIn()) {
        if (typeof this.id === 'undefined') {
          this.loadQueriesData(() => {
            this.newQueryDefaultSearch = this.targetEngine
            this.$store.commit('setShowShareSetNameModal', true)
          })
        } else {
          this.$store.commit('setShowShareModal', true)
        }
      }
    },
    handleViewClick (layout) {
      if (layout === availableLayouts[2]) {
        this.handleTreeViewClick()
      } else {
        this.previousLayout = this.layout
        this.handleLayoutClick(layout)
      }
    },
    handleTreeViewClick () {
      this.treeViewJson = this.$refs.graph.getJson()
      this.showTreeView = true
    },
    handleLayoutClick (layout) {
      this.layout = layout
      this.bus.$emit('setOverallLayout', layout.toLowerCase() || null)
    },
    handleTreeViewClose () {
      this.showTreeView = false
      this.layout = this.previousLayout
      this.updateViewDropdownValue = true
    },
    _saveLocal () {
      const query = this.formulateQueryJson(this.id, this.query ? this.query.name : null, this.queryDefaultSearchName())
      saveLocalData(LOCAL_DATA_KEY, JSON.stringify(query))
      saveTargetPath('/query')
    },
    _saveLocalAndEnsureLoggedIn () {
      this._saveLocal()
      if (!isLoggedIn()) {
        this.loginWithConfirmation()
        return false
      } else {
        return true
      }
    },
    handleSaveClick () {
      this.hideMenu()
      if (this._saveLocalAndEnsureLoggedIn()) {
        if (isEmailVerified()) {
          if (this.query && this.query.name === null) {
            this.processSaveAsClick()
          } else {
            this.processSaveClick()
          }
        } else {
          this.$store.commit('setIsShowingSpinner', true)
          initialiseProfile(this.processSaveClick)
        }
      }
    },
    processSaveClick () {
      this.$store.commit('isLoggedIn', false)
      if (isEmailVerified()) {
        if (typeof this.id === 'undefined') {
          this.newQueryDefaultSearch = this.targetEngine
          this.loadQueriesData(() => {
            this.$store.commit('setShowSaveModal', true)
          })
          this.newQueryName = this.query && this.query.name ? this.query.name : null
        } else {
          this.saveQuery(this.query.name, this.queryDefaultSearchName(),
            () => this.showSnackbar(this.$t('notification.snackbar.fileSaved')),
            () => this.showSnackbar(this.$t('notification.snackbar.saveFailed'))
          )
        }
      } else {
        this.showVerifyEmailModal()
      }
    },
    handleSaveConfirmation (fileName) {
      this.$store.commit('setShowSaveModal', false)
      this.query.name = this.newQueryName = fileName
      this.saveQuery(this.newQueryName, this.newQueryDefaultSearch.name,
        () => this.showSnackbar(this.$t('notification.snackbar.fileSaved')),
        () => this.showSnackbar(this.$t('notification.snackbar.saveFailed'))
      )
    },
    handleSaveClose () {
      this.$store.commit('setShowSaveModal', false)
      this.$store.commit('setShowMainMenu', false)
    },
    handleSaveAsClick () {
      this.hideMenu()
      if (this._saveLocalAndEnsureLoggedIn()) {
        if (isEmailVerified()) {
          this.processSaveAsClick()
        } else {
          this.$store.commit('setIsShowingSpinner', true)
          initialiseProfile(this.processSaveAsClick)
        }
      }
    },
    processSaveAsClick () {
      this.$store.commit('setIsShowingSpinner', false)
      if (isEmailVerified()) {
        this.saveAsName = null
        this.saveAsDefaultSearch = this.targetEngine
        this.loadQueriesData(() => {
          this.$store.commit('setShowSaveAsModal', true)
        })
      } else {
        this.showVerifyEmailModal()
      }
    },
    handleSaveAsConfirmation (fileName) {
      this.saveAsName = this.query.name = fileName
      this.saveQuery(this.saveAsName, this.saveAsDefaultSearch.name,
        () => {
          this.showSnackbar(this.$t('notification.snackbar.fileSaved'))
          this.handleSaveAsClose()
        },
        () => this.showSnackbar(this.$t('notification.snackbar.saveFailed')),
        true
      )
    },
    handleSaveAsClose () {
      this.$store.commit('setShowSaveAsModal', false)
      this.$store.commit('setShowMainMenu', false)
    },
    handleEnterQueryStringClick () {
      this.hideMenu()
      this.$store.commit('setShowEnterQueryStringModal', true)
    },
    handleQueryNameClick () {
      this.bus.$emit('stopTour')
      if (this._saveLocalAndEnsureLoggedIn()) {
        if (isEmailVerified()) {
          let setToUnnamed = false
          if (this.query.name === null) {
            setToUnnamed = true
          } else {
            if (typeof this.query.name === 'undefined' ||
                this.query.name === null ||
                this.query.name === '') {
              setToUnnamed = true
            }
          }
          if (setToUnnamed) {
            this.newQueryName = this.$t('headerNavBar.untitledFile')
          } else {
            this.newQueryName = this.query.name
          }
          if (this.query) {
            this.newIsPublic = this.query.isPublic
            this.newQueryDefaultOperator = this.query.defaultOperator
            this.newQueryDefaultSearch = this.getDefaultSearchFromName(this.query.defaultSearchName)
            this.newQueryNotes = this.query.notes
          } else {
            this.newIsPublic = baseQueryAttributes.isPublic
            this.newQueryDefaultOperator = baseQueryAttributes.defaultOperator
            this.newQueryDefaultSearch = this.getDefaultSearchFromName(this.targetEngine.name)
          }
          this.loadQueriesData(() => {
            this.$store.commit('setShowQuerySettingsModal', true)
          })
        } else {
          this.showVerifyEmailModal()
        }
      }
    },
    showVerifyEmailModal () {
      this.$store.commit('setInformationTitle', this.$t('modal.verifyEmail.title'))
      this.$store.commit('setInformationBody', this.$t('modal.verifyEmail.body'))
      this.$store.commit('setShowInformationModal', true)
    },
    handleQuerySettingsConfirmation (newDetails) {
      this.newQueryName = this.query.name = newDetails.newQueryName
      this.newQueryDefaultOperator = this.query.defaultOperator = newDetails.newQueryDefaultOperator
      this.newQueryNotes = this.query.notes = newDetails.newQueryNotes
      // @todo - sometimes searchEngine is not passed
      this.newQueryDefaultSearch = newDetails.newQueryDefaultSearchName || this.getDefaultSearchFromName(newDetails.newQueryDefaultSearchName)
      this.query.defaultSearchName = this.newQueryDefaultSearch
      
      this.query.isPublic = this.newIsPublic
      if (this.newQueryName && this.newQueryName !== '') {
        this.saveQuery(this.newQueryName, this.newQueryDefaultSearch,
          () => {
            this.successHandleQuerySettingsConfirmation()
            this.$store.commit('setShowQuerySettingsModal', false)
          },
          () => this.showSnackbar(this.$t('notification.snackbar.settingsSaveFailed'))
        )
      }
      if (this.$store.state.appState.showResultsSection) {
        this.updateResults()
      }
    },
    successHandleQuerySettingsConfirmation () {
      this.showSnackbar('Properties saved')
      this.setTargetEngineFromName(this.query.defaultSearchName)
    },
    handleFileDrop (e) {
      event.preventDefault()
      const files = event.dataTransfer.files
      this.importFiles(files)
    },
    formulateQueryJson (queryId, name, defaultSearchName) {
      const userId = getUserId()
      let isPublic = false
      if (this.query && this.query.isPublic) {
        isPublic = true
      }
      return {
        _id: queryId,
        ownerId: userId,
        name: name,
        defaultSearchName: defaultSearchName,
        body: this.$refs.graph.getJson(),
        isPublic: isPublic,
        defaultOperator: this.query
          ? this.query.defaultOperator : defaultOperatorName,
        notes: this.query ? this.query.notes : null,
        updatedAt: new Date(),
        layout: nestedLayoutName
      }
    },
    saveQuery (name, defaultSearchName, successCallback, failureCallback, setNewId) {
      let settingNewId = false
      if (setNewId || typeof this.id === 'undefined') {
        settingNewId = true
      }
      let queryId = settingNewId ? null : this.id
      let overwriting = false
      const userId = getUserId()
      if (userId === null || typeof userId === 'undefined') {
        console.warn('saveQuery but no userId')
        if (failureCallback) {
          failureCallback()
        }
      }
      if (this.queries) {
        const matches = this.queries.filter(q => q.name === name)
        if (matches.length > 0) {
          queryId = matches[0]._id
          overwriting = true
        }
      }
      const query = this.formulateQueryJson(queryId || undefined, name, defaultSearchName)
      saveLocalData(LOCAL_DATA_KEY, JSON.stringify(query))
      const p = (settingNewId && !overwriting)
        ? createQuery(query)
        : updateQuery(query)
      p.then(r => {
        if (r.status === statusEnum.unauthorised) {
          this.loginWithConfirmation()
        } else if (r.status === statusEnum.error) {
          if (failureCallback) {
            failureCallback()
          }
        } else if (r.status === statusEnum.ok) {
          this.hasUnsavedChanges = false
          clearLocalData(LOCAL_DATA_KEY)
          const idChanged = !settingNewId && r.response.query._id !== query._id
          if (settingNewId || overwriting || idChanged) {
            this.$router.push({name: 'Query', params: {id: r.response.query._id}})
          } else {
            this.query.name = name
          }
          if (successCallback) {
            successCallback()
          }
        }
      })
    },
    hideMenu () {
      this.$store.commit('setShowMainMenu', false)
    },
    hideProfileMenu () {
      this.$store.commit('setShowProfileMenu', false)
    },
    toggleResults () {
      this.bus.$emit('stopTour')
      this.$store.commit('toggleShowResultsSection')
      if (this.$store.state.appState.showResultsSection) {
        this.updateResults()
      } else {
        this.subqueryGraphData = null
      }
      this.bus.$emit('relayout')
    },
    newTabResults () {
      this.updateResults()
      this.openExternalResultsWindow()
    },
    openExternalResultsWindow () {
      this.externalResultsWindow = window.open(this.resultsUrl, EXTERNAL_RESULTS_WINDOW_NAME)
    },
    outputData () {
      this.bus.$emit('outputData')
    },
    sortTreeData (treeData) {
      if (treeData && treeData.children) {
        for (const i of treeData.children) {
          if (i.children && i.children.length > 0) {
            this.sortTreeData(i)
          }
        }
        treeData.children.sort((a, b) => {
          if (a.ordering === null && b.ordering === null) {
            return 0
          }
          if (a.ordering === null) {
            return -1
          }
          if (b.ordering === null) {
            return 1
          }
          return a.ordering - b.ordering
        })
      }
      return treeData
    },
    _updateResults () { // The method updateResults (without leading underscore) is a debounced version of this method.
      let qToRun = null
      let queryGraphData = null
      this.targetEngine.searchEngine.setAddQuotesAroundPhrases(this.addQuotesAroundPhrases)
      this.polyglotEngine.setAddQuotesAroundPhrases(this.addQuotesAroundPhrases)
      if (this.subqueryGraphData === null) {
        const s = this.$refs.graph.getTreeData(this.query
          ? this.query.defaultOperator
          : defaultOperatorName)
        if (s) {
          const treeData = this.sortTreeData(s) // TODO: Consider sorting in _tidyUpQueryData and whenever graph changed
          qToRun = this.targetEngine.searchEngine.formulateQueryFromTreeData(treeData)
          this.$store.commit('setPolyglotString', decodeURIComponent(this.polyglotEngine.formulateQueryFromTreeData(treeData)))
        }
        queryGraphData = s
      } else {
        queryGraphData = this.subqueryGraphData
        qToRun = this.subqueryIsGroup
          ? this.targetEngine.searchEngine.formulateQueryFromTreeData(queryGraphData)
          : this.targetEngine.searchEngine.formulateQueryFromNodeData(queryGraphData)
        this.$store.commit('setPolyglotString', decodeURIComponent(this.polyglotEngine.formulateQueryFromTreeData(this.subqueryGraphData)))
      }
      if (this.polyglotString) {
        const polyglotString = this.polyglotString
        this.$store.commit('setPolyglotString', polyglotString.replace(orNotReplaceRE, ' NOT '))
      }

      if (qToRun && this.subqueryGraphData === null &&
          this.targetEngine.searchEngine.canGetCount() &&
          queryGraphData.children) {
        const terms = queryGraphData.children.map(x => {
          return {
            key: x.key,
            terms: x.isGroup
              ? this.targetEngine.searchEngine.formulateQueryFromTreeData(x)
              : this.targetEngine.searchEngine.formulateQueryFromNodeData(x)
          }
        })
        this.targetEngine.searchEngine.getCount(terms).then(r => {
          this.bus.$emit('setCounts', r)
        }).catch(r => {
          this.showSnackbar(this.$t('notification.snackbar.countsFailed'))
        })
      }

      if (qToRun) {
        qToRun = qToRun.trim()
        this.$store.commit('setCanvasHasTerms', true)
      } else {
        this.$store.commit('setCanvasHasTerms', false)
      }
      const previousResultsUrl = this.resultsUrl
      // this.resultsUrl = this.targetEngine.searchEngine.formulateQuery(qToRun)
      // this.setResultsUrl(this.targetEngine.searchEngine.formulateQuery(qToRun))
      this.$store.commit('setResultsUrl', this.targetEngine.searchEngine.formulateQuery(qToRun))
      if (this.$store.state.appState.showResultsSection || (this.externalResultsWindow !== null && this.externalResultsWindow.closed === false)) {
        const temp = this.targetEngine.searchEngine.formulateDisplayQuery(qToRun)
        // this.$store.commit('setBooleanString', this.targetEngine.searchEngine.formulateDisplayQuery(qToRun))
        this.$store.commit('setBooleanString', temp)

        if (this.externalResultsWindow !== null &&
            this.externalResultsWindow.closed === false &&
            this.resultsUrl !== previousResultsUrl
        ) {
          this.externalResultsWindow.location.href = this.resultsUrl
        }
        this.$store.commit('setQueryMessage', this.targetEngine.searchEngine.lintQuery(queryGraphData))
      }
      if (this.resultsUrl !== previousResultsUrl) {
        const duplicates = this.findDuplicates(queryGraphData)
        this.bus.$emit('setDuplicates', duplicates)
      }
      const statistics = this.$refs.graph.getStatistics()
      this.queryStatistics.termsText = this._formulateStatisticsText(statistics.terms, 'term', statistics.distinctTerms)
      this.queryStatistics.fieldTagsText = this._formulateStatisticsText(statistics.fieldTags, 'field tag', statistics.distinctFieldTags)
      this.queryStatistics.operatorsText = this._formulateStatisticsText(statistics.operators, 'operator', statistics.distinctOperators)
    },
    _formulateStatisticsText (count, label, distinctCount) {
      const ofPart = count > 1 ? ` (of ${distinctCount} different types)` : ''
      return `${count} ${label}${count === 1 ? '' : 's'}${ofPart}`
    },
    findDuplicates (treeData) {
      if (!treeData) {
        return []
      }
      const duplicates = []
      const concepts = []
      const ignoreCharactersRE = /["]/g
      for (const i of treeData.children) {
        if (i.isGroup) {
          if (i.children && i.children.length > 0) {
            duplicates.push(...this.findDuplicates(i))
          }
        } else {
          concepts.push({key: i.key, text: i.text, fieldSpecifier: i.fieldSpecifier})
        }
      }
      concepts.forEach(t1 => {
        if (t1.text && concepts.filter(t2 => {
          if (t2.text) {
            const t1Text = t1.text.replace(ignoreCharactersRE, '')
            const t2Text = t2.text.replace(ignoreCharactersRE, '')
            return t1Text === t2Text && t1.fieldSpecifier === t2.fieldSpecifier
          } else {
            return false
          }
        }).length > 1) {
          duplicates.push(t1)
        }
      })
      return duplicates
    },
    reloadResults () {
      const url = this.resultsUrl
      const handleExternal = this.externalResultsWindow !== null && this.externalResultsWindow.closed === false
      // this.resultsUrl = this.targetEngine.searchEngine.formulateQuery('') // Needs to be set to something so that the data is pushed down to the iframe by Vue
      this.setResultsUrl(this.targetEngine.searchEngine.formulateQuery('')) // Needs to be set to something so that the data is pushed down to the iframe by Vue
      if (handleExternal) {
        this.externalResultsWindow.location.href = ''
      }
      this.$nextTick(() => {
        // this.resultsUrl = url
        this.setResultsUrl(url)
        if (handleExternal) {
          this.externalResultsWindow.location.href = url
        }
      })
    },
    handleLogin () {
      login()
    },
    handleLogout () {
      clearLocalData(LOCAL_DATA_KEY)
      clearUserDetails()
      logout()
      this.hideMenu()
      this.showSnackbar(this.$t('notification.snackbar.loggedOutSuccess'))
    },
    isLoggedIn () {
      return isLoggedIn()
    },
    loginWithConfirmation () {
      this.showConfirmLogin = true
    },
    getName () {
      const profile = getProfile()
      if (profile) {
        return profile.nickname
      } else {
        return null
      }
    },
    getEmailAddress () {
      const profile = getProfile()
      if (profile) {
        return profile.email
      } else {
        return null
      }
    },
    getIsTester () {
      return getIsTester()
    },
    listQueries () {
      this.hideMenu()
      // After making changes in a canvas and then clicking on OPEN it opened up a modal which is now not being displayed as requested in PRESS-339 which is why below if-else condition is commented
      // if (this.hasUnsavedChanges) {
      //   this.$store.commit('setShowNewConfirmationModal', true)
      // } else {
        if (this._saveLocalAndEnsureLoggedIn()) {
          clearLocalData(LOCAL_DATA_KEY)
          this.loadQueriesData(() => {
            this.$store.commit('setShowListQueriesModal', true)
          })
        }
      // }
    },
    handleImportClick () {
      this.hideMenu()
      if (this._saveLocalAndEnsureLoggedIn()) {
        this.loadQueriesData(() => {
          this.$store.commit('setShowImportModal', true)
        })
      }
    },
    loadQueriesData (successCallback) {
      this.$store.commit('setIsShowingSpinner', true)
      getQueries().then(r => {
        this.$store.commit('setIsShowingSpinner', false)
        if (r.status === statusEnum.unauthorised) {
          this.loginWithConfirmation()
        } else if (r.status === statusEnum.error) {
          this.showSnackbar(this.$t('notification.snackbar.dataFetchingFailed'))
        } else if (r.status === statusEnum.ok) {
          this.queries = r.response.queries
          if (successCallback) {
            successCallback()
          }
        }
      })
    },
    handleNewCanvasClick () {
      this.hideMenu()
      this.$store.commit('setShowNewSearchModal', true)
    },
    handleOpenBlankCanvas () {
      this.$store.commit('setShowNewSearchModal', false)
      this.startNewQuery()
      if (this.$route.params.id !== undefined) {
        this.$router.push({name: 'Query'})
      }
    },
    handleNewSearchModalClose () {
      this.$store.commit('setShowNewSearchModal', false)
    },
    handleOpenCanvasWithId (canvasId) {
      // this.resultsUrl = null
      this.setResultsUrl(null)
      this.$router.push({ name: 'Query', params: { id: canvasId } })
    },
    handleOpenCuratedSearch (selectedSampleId) {
      // this.resultsUrl = null
      this.setResultsUrl(null)
      this.$router.push({ name: 'New Query Import', params: { importId: selectedSampleId } })
      this.$router.go()
    },
    handleNewConfirmedClick () {
      this.$store.commit('setShowNewConfirmationModal', false)
      this.hasUnsavedChanges = false
      this.listQueries()
    },
    startNewQuery () {
      this.query = Object.clone(baseQueryAttributes, true)
      this.hasUnsavedChanges = false
      // this.resultsUrl = null
      this.setResultsUrl(null)
      clearLocalData(LOCAL_DATA_KEY)
      this.bus.$emit('clear')
      this.updateResults()
    },
    formulateDownloadName (base) {
      const todayDateFormatted = new Date().toISOString().substring(0, new Date().toISOString().length - 8).replace('T', '_').replace(':', '-')
      let r = `Untitled Canvas ${todayDateFormatted}.tds`
      if (base && base.trim().length > 0) {
        r = base
        if (r.substring(base.length - fileExtension.length, base.length) !== fileExtension) {
          r += fileExtension
        }
      }
      return r
    },
    handleGenerateSearchReport () {
      this.hideMenu()
      this.$store.commit('setShowGenerateSearchReport', true)
    },
    handleGenerateConfirmation ([body, searchDate]) {
      this.$store.commit('setShowGenerateSearchReport', false)
      this.commonFileDownload(body, `search_report-${searchDate}.txt`, 'text/txt')
    },
    handleDownloadClick () {
      this.hideMenu()
      const filename = this.formulateDownloadName(this.query.name)
      this.commonFileDownload(this.$refs.graph.getJson(), filename, 'text/txt')
    },
    commonFileDownload (blobSource, filename, fileType) {
      const blob = new Blob([blobSource], {type: fileType})
      // Based on https://stackoverflow.com/questions/3665115/create-a-file-in-memory-for-user-to-download-not-through-server
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename)
      } else {
        const elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = filename
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
      }
    },
    handleImportFileClick () {
      this.hideMenu()
      document.getElementById('fileUploadInputField').click()
    },
    handleHowToUseClick () {
      window.open(howToUseUrl, '_blank')
    },
    handleTourClick () {
      this.bus.$emit('startTour', false)
    },
    handleAboutClick () {
      window.open(aboutUrl, '_blank')
    },
    handleRequestDemoClick () {
      window.open(requestDemoUrl, '_blank')
    },
    handleFilesChange (fieldName, fileList) {
      if (typeof window.File === 'undefined' ||
        typeof window.FileList === 'undefined' ||
        typeof window.FileReader === 'undefined') {
        alert('Unfortunately this browser does not support importing a file')
        return
      }
      this.importFiles(fileList)
      document.getElementById('fileUploadInputField').value = null // Clear the file selection so next import can be same
      this.updateResults()
      this.hideMenu()
    },
    importFiles (fileList) {
      for (let i = 0; i < fileList.length; i++) {
        const f = fileList[i]
        const reader = new FileReader()
        reader.onload = (fileRead => {
          return (e) => {
            var j = JSON.parse(e.target.result)
            if (j.nodeDataArray && j.nodeDataArray.length > 0) {
              this.bus.$emit('addData', j.nodeDataArray)
            }
          }
        })(f)
        reader.readAsText(f)
      }
    },
    importFromUrl (url) {
      axios.get(url)
        .then(response => {
          var j = response.data
          if (j.nodeDataArray && j.nodeDataArray.length > 0) {
            this.bus.$emit('addData', j.nodeDataArray)
            this.updateResults()
          } else {
            this.showSnackbar(this.$t('notification.snackbar.noDataFoundToAdd'))
          }
        })
        .catch(r => {
          this.showSnackbar(this.$t('notification.snackbar.urlReadFailed'))
          console.warn(r)
        })
    },
    queryDefaultSearchName () {
      if (this.query && typeof this.query.defaultSearchName !== 'undefined' && this.query.defaultSearchName !== null) {
        return this.query.defaultSearchName
      } else {
        return this.targetEngine.name
      }
    },
    handleShareSetNameConfirmation () {
      this.$store.commit('showShareSetNameConfirmation', false)
      this.query.name = this.newQueryName
      this.saveQuery(this.newQueryName, this.queryDefaultSearchName(),
        () => {
          this.showSnackbar(this.$t('notification.snackbar.fileSaved'))
          this.handleShareSetNameClose()
        },
        () => this.showSnackbar(this.$t('notification.snackbar.nameSaveFailed'))
      )
      this.$store.commit('setShowShareModal', true)
    },
    handleShareSetNameClose () {
      this.$store.commit('setShowShareSetNameModal')
    },
    handleShareConfirmation () {
      this.query.isPublic = true
      this.$store.commit('setShowShareModal', false)
      textToClipboard(this.shareUrl)
      this.saveQuery(this.query.name, this.queryDefaultSearchName(),
        () => {
          this.showSnackbar(this.$t('notification.snackbar.copyClipboard'))
        },
        () => {
          this.showSnackbar(this.$t('notification.snackbar.updateSaveFailed'))
        }
      )
    },
    _loadLocalQuery () {
      const localQueryData = getLocalData(LOCAL_DATA_KEY)
      const localQuery = localQueryData === null ? null : JSON.parse(localQueryData)
      if (localQuery) {
        if (typeof this.id === 'undefined' && typeof localQuery._id !== 'undefined') {
          // If local query found and it has an id on it then reroute to that
          // query and on coming back into this method load from local.
          this.$router.push({ name: 'Query', params: { id: localQuery._id } })
        } else {
          this.query = localQuery
          this.hasUnsavedChanges = true
          this.showSnackbar(this.$t('notification.snackbar.changesNotSaved'))
        }
        return true
      } else {
        return false
      }
    },
    prepareData () {
      if (!this.importId) {
        if (this.id && (this.query === null || this.query._id !== this.id)) {
          saveCurrentPage()
          this.getQuery()
        } else {
          this._loadLocalQuery()
          if (this.query === null) {
            this.query = Object.clone(baseQueryAttributes, true)
          } else {
            this.setTargetEngineFromName(this.query.defaultSearchName)
          }
        }
      } else {
        this.hasUnsavedChanges = false
        // this.resultsUrl = null
        this.setResultsUrl(null)
        clearLocalData(LOCAL_DATA_KEY)
        getQueryPublic(this.importId).then(r => {
          if (r.status === statusEnum.ok) {
            this.lastIdLoadFailed = null
            this.query = r.response.query
            this.setTargetEngineFromName(this.query.defaultSearchName)
            this.hasUnsavedChanges = true
            this.$nextTick(() => {
              this.bus.$emit('setOverallLayout', this.layout.toLowerCase() || null)
            })
          } else {
            this.lastIdLoadFailed = this.id
            this.query = Object.clone(baseQueryAttributes, true)
            this.showCannotFetchDataInformation()
          }
          this.$router.push({name: 'Query'})
        })
      }
      if (this.showDefaultQuery) {
        this.query = defaultQueryForDisplay()
        this.setTargetEngineFromName(this.query.defaultSearchName)
      }
      if (!hasSeenTour() && !this.importId) {
        this.bus.$emit('startTour', true)
        if (isLoggedIn()) {
          setHasSeenTour()
        }
      }
    },
    showCannotFetchDataInformation () {
      this.$store.commit('setInformationTitle', this.$t('modal.cannotFetchData.title'))
      this.$store.commit('setInformationBody', this.$t('modal.cannotFetchData.body') + this.importId)
      this.$store.commit('setShowInformationModal', true)
    },
    showSnackbar (text) {
      this.$store.commit('setSnackbarText', text)
    },
    handleSuggestTermsClose () {
      this.showingSuggestTerms = false
    },
    handleSuggestTermsConfirmed (chosenTerms, termKey, groupKey) {
      this.bus.$emit('addTerms', chosenTerms, termKey, groupKey)
      this.showingSuggestTerms = false
    },
    openSuggestTerms (term, termKey, groupKey) {
      this.suggestTerms.term = term
      this.suggestTerms.groupKey = groupKey
      this.suggestTerms.termKey = termKey
      this.$store.commit('setIsShowingSpinner', true)
      getRelevantKeywords(term)
        .then(r => {
          this.$store.commit('setIsShowingSpinner', false)
          this.suggestTerms.suggestions = r.response
          this.showingSuggestTerms = true
        })
    },
    handleShowUserSettings () {
      this.hideMenu()
      if (isLoggedIn()) {
        this.$store.commit('setShowUserSettingsModal', true)
      } else {
        login()
      }
    },
    handleUserSettingsUpdated () {
      this.$store.commit('setShowUserSettingsModal', false)
      this.snapToGrid = getSnapToGrid()
      this.addQuotesAroundPhrases = getAddQuotesAroundPhrases()
      this.updateResults()
    },
    handleUserSettingsUpdateFailed () {
      this.showSnackbar(this.$t('notification.snackbar.settingsSaveFailedVerbose'))
    },
    setDefaultSearch (setTarget) {
      const userDefaultSearch = getDefaultSearch()
      const e = POSSIBLE_ENGINES.find(x => {
        return x.name === userDefaultSearch.name
      })
      if (e) {
        if (setTarget) {
          this.targetEngine = e
        }
        this.defaultEngine = e
      }
    },
    handleBeforeUnload () {
      this._saveLocal()
    },
    handleTreeViewQueryUpdated (e) {
      let updated = false
      e.object.changes.each((x) => {
        if (x.propertyName === 'text' && x.model && x.object) {
          this.bus.$emit('updateText', {key: x.object.key, text: x.object.text})
          updated = true
        }
      })
      if (updated) {
        this.isLoading = false
        this._postQueryChanged()
      }
    },
    _postQueryChanged () {
      this.hasUnsavedChanges = true
      this.subqueryGraphData = null
      this.updateResults()
    },
    launchGeneratorQuery (generatorFinalQueryAndMethod) {
      this.parseStringModalBooleanString = generatorFinalQueryAndMethod[0]
      this.handleParseStringConfirmation(generatorFinalQueryAndMethod)
    }
  },
  created () {
    Sugar.extend()
    window.addEventListener('beforeunload', this.handleBeforeUnload, false)
    this.bus.$on('queryChanged', () => {
      if (this.isLoading) {
        this.isLoading = false
        return
      }
      this._postQueryChanged()
    })
    this.bus.$on('subqueryRequested', (td) => {
      this.subqueryIsGroup = td.isGroup
      this.subqueryGraphData = td
      this.updateResults()
    })
    this.bus.$on('showSearchResultsRequested', () => {
      this.$store.commit('setShowResultsSection', true)
    })
    this.bus.$on('loadAndShowResults', () => {
      this.$store.commit('setShowResultsSection', true)
      this.updateResults()
    })
    this.bus.$on('hideResults', () => {
      this.$store.commit('setShowResultsSection', false)
    })
    this.bus.$on('suggestTerms', (term, termKey, groupKey) => {
      this.openSuggestTerms(term, termKey, groupKey)
    })
    this.bus.$on('showLhsMenu', () => {
      this.$store.commit('setShowMainMenu', true)
    })
    this.bus.$on('hideLhsMenu', () => {
      this.$store.commit('setShowMainMenu', false)
    })
    this.bus.$on('initialDataLoaded', () => {
      this.updateResults()
    })
    this.bus.$on('listQueries', () => {
      this.listQueries()
    })
    this.bus.$on('showingContextMenu', () => {
      this.bus.$emit('stopTour')
    })
  },
  mounted () {
    this.$store.commit('setResultsContainerWidth', window.innerWidth / 2)
    this.setDefaultSearch(true) // Do this before call to prepareData so that target engine is set correctly for default starter query
    this.updateResults = this._updateResults.debounce(500)
    this.prepareData()
    this.snapToGrid = getSnapToGrid()
    this.addQuotesAroundPhrases = getAddQuotesAroundPhrases()
  },
  watch: {
    id: function (val, oldVal) {
      this.prepareData()
    },
    updateTargetEngine: function (val) {
      if (val) {
        this.handleTargetEngineClick(this.targetSource)
      }
    }
  },
  computed: {
    console: () => console,
    showSaveModal: { get () { return this.$store.state.modalState.showSaveModal } },
    showSaveAsModal: { get () { return this.$store.state.modalState.showSaveAsModal } },
    showEnterQueryStringModal: { get () { return this.$store.state.modalState.showEnterQueryStringModal } },
    showGenerateSearchReport: { get () { return this.$store.state.modalState.showGenerateSearchReport } },
    showShareSetNameModal: { get () { return this.$store.state.modalState.showShareSetNameModal } },
    resultsUrl: { get () { return this.$store.state.queryState.resultsUrl } },
    updateTargetEngine: { get () { return this.$store.getters.getUpdateTargetEngine } },
    targetSource: { get () { return this.$store.getters.getTargetSource } },
    queryBody: function () {
      if (this.id !== this.lastIdLoadFailed && this.query) {
        return this.query.body
      } else {
        return null
      }
    },
    hasUnsavedChangesAndNotLoading: function () {
      return !this.isLoading && this.hasUnsavedChanges
    },
    shareUrl: function () {
      return window.location.protocol + '//' + window.location.hostname +
        ((window.location.port && window.location.port.length > 0) ? (':' + window.location.port) : '') +
        '/new-query/' + this.id
    },
    enabledEngines: function () {
      return this.possibleEngines.filter(e => e.enabled)
    },
    messagesCount: function () {
      return this.$store.state.queryState.queryMessage.length
    },
    isLayoutInline: function () {
      return this.layout === inlineLayoutName
    },
    showPolyglotQueries: function () {
      return this.targetEngine.showPolyglotQueries
    }
  }
}
</script>

<!--  @todo - Check if all css is used in this file or should be moved to component  -->
<style lang="scss" scoped>
body {
  background-color: #657D8A;
}
// Helper
.center {
  display: flex;
  align-items: center;
}
.toolbar .caption {
  vertical-align: middle;
}
// -> Dropdown component
.tds-toolbar-drop-down {
  background-color: white;
  z-index: 5000;
}
.tds-drop-down-item-disabled {
  color: $grey-400;
}
#tds-drop-down-last-item-title{
  display: flex;
  justify-content: space-between;
}
.tds-drop-down-item-unselected, #tds-drop-down-last-item {
  margin-left: 1.2rem;
}
#source-drop-down {
  margin-right: 1rem;
}
// Side Menu
.navigation-drawer {
  z-index: 500;
}
#div-cover-behind-results-slider {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 199;
}
// Results Pane
#div-results {
  position: absolute;
  top: $length-large-xs;
  z-index: 90;
  background-color: white;
  right: 0;
  min-width: $length-xlarge-l;
  margin-left: $length-small-xl;
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  text-align: left;
  box-shadow: 0 $length-small-l $length-small-xl -5px rgba(0,0,0,.2), 0 $length-med-s $length-med-m $length-small-s rgba(0,0,0,.14), 0 $length-small-l $length-med-l 5px rgba(0,0,0,.12);
}
#div-results-iframe {
  height: 100%;
  width: 100%;
  float: left;
}
#div-results-iframe iframe {
  height: 100%;
  width: calc(100% - 10px);
  border: none;
}
//#div-results-lhs {
//  position: absolute;
//  display: flex;
//  height: 100%;
//  width: $length-small-xl;
//  cursor: ew-resize;
//  z-index: 1000;
//  background-color: $grey-300;
//}
//#div-results-lhs-drag-icon {
//  margin-left: -7px;
//}
#div-results-rhs {
  position: absolute;
  top: 0;
  left: $length-small-xl;
  height: 100%;
  width: calc(100% - .75rem);
  z-index: 400;
}
.copy-icon {
  margin-left: $length-small-l;
}
#results-url-link:hover {
  text-decoration: underline;
}
.tabs__items, .tabs__content {
  height: 100%;
  background-color: white;
}
.tabs__content .card__text {
  overflow-wrap: break-word;
}
#fileUploadInputField {
  opacity: 0;
  position: absolute;
  top: 0;
}
#floatingControls, #treeViewFloatingControls {
  position: absolute;
  left: $length-small-xl;
  z-index: 100;
}
#floatingControls {
  bottom: $length-small-xl;
}
#treeViewFloatingControls {
  bottom: $length-med-m;
}
.tdsSquareButton.btn {
  min-width: inherit;
  border-radius: 0;
  margin-top: $length-small-s;
  margin-bottom: 0;
  padding: 0 $length-small-s 0 $length-small-s;
  // box-shadow: $length-small-s $length-small-s $length-small-xs $length-small-xs rgba(94, 109, 118, .4), 0 $length-small-s $length-small-s 0 rgba(94, 109, 118, .14), 0 $length-small-xs 5px 0 rgba(94, 109, 118, .12)
}
.tdsSquareButton.btn.tdsStrongShadow {
  box-shadow: $length-small-s $length-small-s $length-small-xs $length-small-xs rgba(94, 109, 118, .7), 0 $length-small-s $length-small-s 0 rgba(94, 109, 118, .4), 0 $length-small-xs 5px 0 rgba(94, 109, 118, .2)
}
#toolbar-show-results-button, #toolbar-show-new-tab-results {
  min-width: inherit;
}
#floatingControls .tdsFirstButton {
  margin-bottom: 5px;
}
.tds-no-iframe-results {
  color: $grey-800;
  font-style: italic;
  margin-top: $length-med-xl;
}
.tds-scroll {
  overflow-y: auto;
}
.text-warning {
  color: $red-500;
}
</style>

<style lang="scss">
.tds-highlight-error {
  font-family: 'Courier', monospace;
}
.tds-highlight-error-characters {
  font-weight: bold;
  color: $red-500;
}
.uxl-icon-badge {
  position: absolute !important;
}
.uxl-icon-badge .badge__badge {
  top: -$length-small-s;
  left: $length-med-xl;
  height: $length-med-xs;
  width: $length-med-xs;
}
.uxl-raised-icon {
  min-width: 0;
}
.uxl-raised-icon.uxl-raised-icon i {
  margin-right: 0;
}
.tds-badge .badge__badge {
  width: $length-med-s;
  height: $length-med-s;
  right: -$length-med-s;
  top: -$length-small-l;
  font-size: $length-small-xl;
}
#div-results-toolbar {
  height: $length-small-xl;
  margin-top: $length-small-xl !important;
  margin-bottom: 36px;
}
#div-results-tabs {
  margin-left: $length-small-xl;
}
.tds-left {
  text-align: left;
}

.tds-statistics td {
  padding-right: $length-small-xl;
}
</style>



// WEBPACK FOOTER //
// src/components/QueryEdit.vue